import { createSelector } from 'reselect'
import type { Shared } from 'types/Shared'
import 'types/Shared'
import { getShared } from './helpers'
export const getIsMobileTraffic = createSelector(
  [getShared],
  ({ isMobileTraffic }: Shared): boolean => isMobileTraffic || false
)